<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <!-- Az adminban nincs bal sáv (app.component › menuRejtve): vissza oda, ahonnan beléptünk. -->
      <ion-button (click)="vissza()" title="Vissza">
        <ion-icon slot="start" name="arrow-back"></ion-icon><span class="csak-asztal">Vissza</span>
      </ion-button>
    </ion-buttons>
    <ion-title>Admin<span *ngIf="!sulinform"> · {{ modNev }}</span></ion-title>
    <ion-buttons slot="end">
      <app-profil-menu [sotetFejlec]="!keretVilagos"></app-profil-menu>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="admin-test">

    <!--  A TERÜLETEK (admin-katalogus.ts › adminTeruletek) a régi gombok ikonjaival. Telefonon
          vízszintesen görgethető sor a tartalom fölött. -->
    <nav class="admin-teruletek" aria-label="Admin területek">
      <button type="button" class="terulet" *ngFor="let t of teruletek; trackBy: trackTerulet"
              [class.aktiv]="t.kulcs === aktivTerulet" [attr.aria-current]="t.kulcs === aktivTerulet ? 'page' : null"
              (click)="teruletNyit(t)">
        <img [src]="t.kep" alt="" width="28" height="28">
        <span class="terulet__cim">{{ t.cim }}</span>
        <span class="terulet__db">{{ t.db }}</span>
      </button>
      <p class="ures-menu" *ngIf="kesz && !teruletek.length">
        Ebben a modulban nincs számodra elérhető adminisztrációs képernyő.
      </p>
    </nav>

    <div class="admin-fo">
      <!-- KERESŐ: minden látható pont, a régi menünéven is (Ctrl+K). -->
      <div class="admin-kereso">
        <label class="admin-kereso__mezo">
          <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
          <span class="sr-only">Keresés az admin pontjai között</span>
          <input #keresoMezo type="search" [(ngModel)]="q" (ngModelChange)="keres()" (keydown)="keresoBillentyu($event)"
                 placeholder="Mit keresel? pl. bizonyítvány, jogosultság, KRÉTA…" autocomplete="off">
          <kbd class="csak-asztal">Ctrl K</kbd>
        </label>
        <div class="admin-kereso__talalatok" *ngIf="q.trim()" role="listbox">
          <button type="button" *ngFor="let pt of talalatok; let i = index; trackBy: trackPont" role="option"
                  class="talalat" [class.kijelolt]="i === kijelolt" (click)="nyit(pt)" (mouseenter)="kijelolt = i">
            <span class="talalat__cim">{{ pt.cim }}</span>
            <span class="talalat__ut">{{ pt.teruletCim }}<ng-container *ngIf="pt.alcsoport"> › {{ pt.alcsoport }}</ng-container></span>
          </button>
          <p class="talalat-nincs" *ngIf="!talalatok.length">Nincs ilyen admin-pont.</p>
        </div>
      </div>

      <!-- Munkatanév-jelzés: előkészítés alatt álló tanéven dolgozunk -->
      <div class="munkatanev-banner" *ngIf="munkatanevEltero">
        <ion-icon name="construct-outline"></ion-icon>
        <span>
          <b>Előkészítés alatt álló tanéven dolgozol: {{ tanevNev(munkatanev) }}</b> —
          a törzsadat-felületek (osztályok, csoportok, tantárgyfelosztás, tantermek) erre az évre mentenek.
          Az aktuális (naplózott) tanév: {{ tanevNev(aktualistanev) }}.
        </span>
        <ion-button size="small" fill="clear" (click)="munkatanevVissza()">
          Vissza az aktuális tanévre
        </ion-button>
      </div>

      <!-- Hol vagyunk: terület › alcsoport › pont (a kezdőlapon nincs). -->
      <div class="admin-morzsa" *ngIf="aktivPont && !kezdolapon">
        <button type="button" class="morzsa-link" (click)="teruletNyitKulcs(aktivPont.terulet)">{{ aktivPont.teruletCim }}</button>
        <ng-container *ngIf="aktivPont.alcsoport"> › {{ aktivPont.alcsoport }}</ng-container>
        › <b>{{ aktivPont.cim }}</b>
      </div>

      <div class="admin-router-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ion-content>
